<template>
  <div
    class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
  >
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="addShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
        <span class="p-l-20 p-r-10">Add Provider</span>
      </button>
    </div>
  </div>
  <dataTable
    :name="'CustomerProviders'"
    ref="agGrid"
    :columnDefs="columnDefs"
    :data="data"
    @removeFromRedis="removeFromRedis($event)"
    @scanErrors="scanErrorsPop = $event.Id"
    @scan="scan"
    @auth="auth"
    @scanQue="scanQue"
    @update="updateShow = $event"
    @remove="remove"
    @providerHotelCodes="providerHotelCodesOpen = $event"
    @senderMailShow="senderMailShow = $event"
    @paximumShow="paximumShow = $event"
    :addContextMenuItem="getContextMenuItems"
    @cellClicked="
      updateShow = $event.column.colId != 'Link' ? $event.data : null
    "
    :rowClassRules="{
      // row style function
      warning: (params) => {
        // var numSickDays = params.data;
        return params?.data?.ControlRequired && !params?.data.Deleted && params?.data.Active;
      },
      internalHotelCodes: (params) => {
        // var numSickDays = params.data;
        return params?.data?.InternalHotelCodes;
      },
      isMailProvider: (params) => {
        // var numSickDays = params.data;
        return params?.data?.IsMailProvider;
      },
      paximumProvider: (params) => {
        return params?.data?.PaximumAPI;
      },
    }"
  ></dataTable>
  <upsert
    v-if="addShow || updateShow != null"
    :CustomerId="setModel.Id"
    @add="$refs.agGrid.addRow([$event])"
    @update="$refs.agGrid.changeRow('Id', $event)"
    :setModel="updateShow"
    @close="
      addShow = false;
      updateShow = null;
    "
  ></upsert>
  <errorList
    v-if="scanErrorsPop != null"
    :CustomerProviderId="scanErrorsPop"
    @close="scanErrorsPop = null"
  ></errorList>
  <modal
    :size="'xl'"
    @close="scanResponseOpen = false"
    v-if="scanResponseOpen != false"
  >
    <template #head>
      <div class="modal-header">
        <h4 class="modal-title">Scan Response</h4>
        <button
          class="btn btn-info btn-xs waves-effect waves-light m-l-5"
          type="button"
          @click="$root.clipboardCopy(JSON.stringify(scanResponse, null, 2))"
          v-if="scanResponse != null"
        >
          <span>Copy</span>
        </button>
      </div>
    </template>
    <template #content>
      <load-area v-if="scanResponse == null"></load-area>
      <pre v-if="scanResponse != null">{{ scanResponse }}</pre>
    </template>
  </modal>
  <hotelCodes
    v-if="providerHotelCodesOpen != null"
    :setModel="providerHotelCodesOpen"
    @close="providerHotelCodesOpen = null"
  ></hotelCodes>
  <senders
    v-if="senderMailShow != null"
    @close="senderMailShow = null"
    :setModel="senderMailShow"
  ></senders>
  <paximum
    v-if="paximumShow != null"
    @close="paximumShow = null"
    :setModel="paximumShow"
  ></paximum>
  <modal
    :size="'xl'"
    @close="authResponseOpen = false"
    v-if="authResponseOpen != false"
  >
    <template #head>
      <div class="modal-header">
        <h4 class="modal-title">Auth Response</h4>
        <button
          class="btn btn-info btn-xs waves-effect waves-light m-l-5"
          type="button"
          @click="$root.clipboardCopy(JSON.stringify(authResponse, null, 2))"
          v-if="authResponse != null"
        >
          <span>Copy</span>
        </button>
      </div>
    </template>
    <template #content>
      <load-area v-if="authResponse == null"></load-area>
      <pre v-if="authResponse != null">{{ authResponse }}</pre>
    </template>
  </modal>
  <modal
    :title="
      'Customer ' +
        openCustomerProviderLogs.ProviderName +
        ' Provider Logs (' +
        openCustomerProviderLogs.Username +
        ')'
    "
    @close="openCustomerProviderLogs = null"
    v-if="openCustomerProviderLogs != null"
    size="xl"
  >
    <template #content>
      <customerProviderLogs
        :customerProviderId="openCustomerProviderLogs.Id"
      ></customerProviderLogs>
    </template>
  </modal>
</template>

<script>
import upsert from "./upsert";
import errorList from "./errorList";
import hotelCodes from "./hotelCodes/main.vue";
import senders from "./senders/main.vue";
import paximum from "./paximum/main.vue";
import customerProviderLogs from "./../../../kolayrez/customerProvidersLogs/list.vue";
import moment from "moment";
export default {
  name: "Providers",
  components: {
    upsert,
    errorList,
    hotelCodes,
    senders,
    paximum,
    customerProviderLogs,
  },
  props: {
    setModel: Object,
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Statu",
          width: 110,
          filter: "agTextColumnFilter",
          field: "statu",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          cellRenderer: function(e) {
            let clas = "success";
            if (e.value == "Deleted") {
              clas = "danger";
            }
            if (e.value == "Control Required") {
              clas = "danger";
            }
            if (e.value == "Passive") {
              clas = "secondary";
            }
            if(e.value != "Deleted" && e.value != "Passive" && e.data.Stopped){
              clas = "info";

            }
            return (
              '<span class="badge badge-' + clas + '">' + (e.value != "Deleted" && e.value != "Passive" && e.data.Stopped?'Stopped':e.value) + "</span>"
            );
          },
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "ProviderName",
          flex: 2,
          minWidth: 180,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          cellRenderer: function(params) {
            if (!params.data.IsMailProvider) return params.value || "";
            return (
              '<div style="display:flex;align-items:center;min-width:0">' +
              '<span class="badge badge-info m-r-5" style="flex-shrink:0;white-space:nowrap"><i class="fas fa-envelope"></i> Mail</span>' +
              '<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + (params.value || "") + "</span>" +
              "</div>"
            );
          },
        },
        {
          headerName: "Username",
          filter: "agTextColumnFilter",
          field: "Username",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Password",
          filter: "agTextColumnFilter",
          field: "Password",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "LastControlDate",
          filter: "agTextColumnFilter",
          field: "LastControlDate",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              let diff = new Date().getTimezoneOffset();
              return moment(
                new Date(params.value).setMinutes(
                  new Date(params.value).getMinutes() - diff
                )
              ).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "StaticProxy",
          width: 120,
          filter: true,
          field: "StaticProxy",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Proxy",
          width: 120,
          filter: "agTextColumnFilter",
          field: "ProxyIP",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 140,
          valueGetter:(params)=>{
            if(params.data.ProxyIP){
              return params.data.ProxyIP + ":" + params.data.ProxyPort
            }
            return "";
          }
        },
        {
          headerName: "Proxy Username",
          width: 140,
          filter: "agTextColumnFilter",
          field: "ProxyUsername",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "Proxy Password",
          width: 140,
          filter: "agTextColumnFilter",
          field: "ProxyPassword",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "Parameter",
          field: "Parameter",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140
        },
        {
          headerName: "Link",
          field: "Link",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<a target='_blank' href='" +
              event.value +
              "'>" +
              event.value +
              "</a>"
            );
          },
        },
        // {
        //   headerName: "",
        //   type: "action",
        //   width: 295,
        //   buttons: [
        //     {
        //       classes:
        //         "btn btn-xs waves-effect waves-light btn-primary paximumButton",
        //       text: '<i class="fas fa-list-ol"></i>',
        //       emit: "paximumShow",
        //     },
        //     {
        //       classes:
        //         "btn btn-xs waves-effect waves-light btn-primary senderMailButton",
        //       text: '<i class="fas fa-paper-plane"></i>',
        //       emit: "senderMailShow",
        //     },
        //     {
        //       classes:
        //         "btn btn-xs waves-effect waves-light btn-primary internalHotelCodesButton",
        //       text: '<i class="fas fa-qrcode"></i>',
        //       emit: "providerHotelCodes",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-danger",
        //       text:
        //         '<i class="mdi mdi-layers-off" style="font-size:14px; line-height:22px;"></i>',
        //       emit: "removeFromRedis",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-danger",
        //       text: '<i class="fas fa-exclamation-triangle"></i>',
        //       emit: "scanErrors",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-primary",
        //       text: '<i class="fas fa-sync-alt"></i>',
        //       emit: "scan",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-primary",
        //       text: '<i class="fas fa-shield-alt"></i>',
        //       emit: "auth",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-primary",
        //       text: '<i class="far fa-plus-square"></i>',
        //       emit: "scanQue",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-warning",
        //       text: '<i class="fas fa-pencil-alt"></i>',
        //       emit: "update",
        //     },
        //     {
        //       classes: "btn btn-xs waves-effect waves-light btn-danger",
        //       text: '<i class="fas fa-trash-alt"></i>',
        //       emit: "remove",
        //     },
        //   ],
        //   filter: false,
        //   sortable: false,
        //   resizable: false,
        //   floatingFilter: false,
        // },
      ],
      data: null,
      addShow: false,
      updateShow: null,
      scanErrorsPop: null,
      scanResponseOpen: false,
      scanResponse: null,
      providerHotelCodesOpen: null,
      senderMailShow: null,
      authResponseOpen: false,
      authResponse: null,
      paximumShow: null,
      openCustomerProviderLogs: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`Customers/` + this.setModel.Id + `/CustomerProviders`)
      .then((response) => {
        this.data = response.data
          .map((x) => {
            let statu = x.Active ? "Active" : "Passive";
            if (x.ControlRequired) {
              statu = "Control Required";
            }
            if (x.Deleted) {
              statu = "Deleted";
            }
            if (!x.Active) {
              statu = "Passive";
            }
            return {
              ...x,
              StaticProxy:x.StaticProxy==null?false:x.StaticProxy,
              statu: statu,
            };
          })
          .sort(
            (x, y) =>
              (x.Deleted ? 3 : x.Active ? 1 : 2) -
              (y.Deleted ? 3 : y.Active ? 1 : 2)
          );
      });
  },
  methods: {
    scan(item) {
      this.scanResponseOpen = true;
      this.scanResponse = null;
      this.$appAxiosKolayrez
        .get(`Helpers/Scan/` + item.Id)
        .then((response) => {
          this.scanResponse = response.data;
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    auth(item) {
      this.authResponseOpen = true;
      this.authResponse = null;
      this.$appAxiosKolayrez
        .get(`Helpers/Auth/` + item.Id)
        .then((response) => {
          this.authResponse = response.data;
        })
        .catch((err) => {
          this.authResponse = err;
        });
    },
    scanQue(item) {
      this.$appAxiosKolayrez
        .post(`Timer/Scan`, {
          CustomerId: null,
          ProviderId: null,
          CustomerProviderId: item.Id,
        })
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: response.data,
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    removeFromRedis(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the redis named " + item.Name + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/CustomerProviders/RemoveFromRedis/` + item.Id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer redis has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the customer provider named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/CustomerProviders/` + item.Id)
            .then(() => {
              this.$refs.agGrid.changeRow("Id", {
                ...item,
                Deleted: false,
                statu: "Deleted",
              });
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer provider has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = ["copy", "export"];

      if (params.node.data.PaximumAPI) {
        result.push({
          name: "Paximum API",
          icon: "<i class='fas fa-list-ol'></i>",
          action: () => {
            this.paximumShow = params.node.data;
          },
        });
      }
      //if (params.node.data.IsMailProvider) {
      //}
        result.push({
          name: "Mail Senders",
          icon: "<i class='fas fa-paper-plane'></i>",
          action: () => {
            this.senderMailShow = params.node.data;
          },
        });
      if (params.node.data.InternalHotelCodes) {
        result.push({
          name: "Provider Hotel Codes",
          icon: "<i class='fas fa-qrcode'></i>",
          action: () => {
            this.providerHotelCodesOpen = params.node.data;
          },
        });
      }
      result.push({
        name: "Remove From Redis",
        icon: "<i class='mdi mdi-layers-off'></i>",
        action: () => {
          this.removeFromRedis(params.node.data);
        },
      });
      result.push({
        name: "Scan Errors",
        icon: "<i class='fas fa-exclamation-triangle'></i>",
        action: () => {
          this.scanErrorsPop = params.node.data.Id;
        },
      });
      result.push({
        name: "Scan",
        icon: "<i class='fas fa-sync-alt'></i>",
        action: () => {
          this.scan(params.node.data);
        },
      });
      result.push({
        name: "Auth",
        icon: "<i class='fas fa-shield-alt'></i>",
        action: () => {
          this.auth(params.node.data);
        },
      });
      result.push({
        name: "Scan Que",
        icon: "<i class='far fa-plus-square'></i>",
        action: () => {
          this.scanQue(params.node.data);
        },
      });
      result.push({
        name: "Update",
        icon: "<i class='fas fa-pencil-alt'></i>",
        action: () => {
          this.updateShow = params.node.data;
        },
      });
      result.push({
        name: "Remove",
        icon: "<i class='fas fa-trash-alt'></i>",
        action: () => {
          this.remove(params.node.data);
        },
      });
      result.push({
        name: "Customer Provider Logs",
        icon: '<i class="far fa-question-circle"></i>',
        action: () => {
          this.openCustomerProviderLogs = params.node.data;
        },
      });
      return result;
    },
  },
};
</script>
<style>
.internalHotelCodesButton {
  display: none;
}

.internalHotelCodes .internalHotelCodesButton {
  display: inline-block;
}

.senderMailButton {
  display: none;
}

.isMailProvider .senderMailButton {
  display: inline-block;
}

.paximumButton {
  display: none;
}

.paximumProvider .paximumButton {
  display: inline-block;
}
.ag-theme-alpine .ag-row.danger {
  background: #fb6a85;
}
</style>
